import { getProvider } from '../../../../../../helpers/getters';

export default (serviceData) => {
  if (serviceData?.form) {
    const { mode, provider_id, provider_service_id } = serviceData.form;
    const isLoadingProvider = serviceData?.isLoadingProvider
    const errorProvider = serviceData?.errorProvider
    /**
     * Sync статуса поддерживают только провайдеры
     * с параметром service_auto_status = true
     */
    if (mode === 1) {
      if (isLoadingProvider) {
        return false;
      }
      if (errorProvider) {
        return false;
      }
      if (provider_id && provider_service_id) {
        const provider = getProvider(provider_id);
        if (provider?.service_auto_status) {
          return provider.service_auto_status
        }
      }
    }
  }
  return false;
};
